// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b75e7410","455":"73042c09","977":"3745baa3"}[chunkId] + ".chunk.js";
};